import { createStorageValue } from '@interhyp/platform-storage';
import { z } from 'zod';
import { portalInterimNamespace } from '../namespaces';
/**
 * Save the embedded flag from the url in a session to keep the value even after routing
 */
export const embeddedValue = createStorageValue({
    namespace: portalInterimNamespace,
    schema: z.boolean(),
    type: 'session',
    id: Symbol('embedded'),
});
